<template>
  <v-card class="back" style="height: 600px">
    <v-layout column fill-height  pa-1>
      <scroll-table
        :data="getTable"
        :options="getOptions"
        :reload="true"
        toolbar="history"
      />
    </v-layout>
  </v-card>
</template>

<script lang="ts">
import Vue from 'vue'
import scrollTable from '@/nms/components/partials/scrolltable.vue'
import { CCMDBObject } from '@entcor/ebridge'

// Типы
interface TableColumn {
  title: string
  value: string
  lastArrayItem?: boolean
  type: string
  width: string
}

interface TableRow {
  [key: string]: any
}

interface TableData {
  columns: TableColumn[]
  rows: TableRow[]
}

interface OptionsColumns {
  [key: string]: { width: string }
}

interface OptionsData {
  columns: OptionsColumns
}

interface ZtpData {
  status?: string[]
  [key: string]: any
}

export default Vue.extend({
  name: 'ZTP_CARD',

  components: {
    scrollTable,
  },

  props: {
    data: {
      type: Object as () => ZtpData,
      default: () => ({})
    },
  },

  data(): {
    options: OptionsData
    search: string
    table: TableData
  } {
    return {
      options: {
        columns: {
          text: { width: '40%' },
          timestamp: { width: '40%' },
          actions: { width: '40%' },
          check: { width: '20%' },
          check_dependence: { width: '5%' },
        },
      },
      search: '',
      table: {
        columns: [],
        rows: [],
      },
    }
  },

  computed: {
    getData(): ZtpData {
      return this.data
    },

    getOptions(): OptionsData {
      return this.options
    },

    getTable(): TableData {
      const t = this.$merge({}, this.table) as TableData

      if (this.search.length) {
        const searchLower = this.search.toLowerCase()
        t.rows = t.rows.filter(row => {
          return row.name?.toLowerCase().indexOf(searchLower) > -1 ||
                 row.status?.toLowerCase().indexOf(searchLower) > -1
        })
        return t
      }
      return this.table
    },
  },

  created(): void {
    this.prepareData()
  },

  methods: {
    async prepareData(): Promise<void> {
      try {
        const status = this.getData.status
        if (status?.length) {
          console.log(this.$options.name, 'prepareData', 'getData', this.getData)

          const columns: TableColumn[] = []
          Object.keys(this.getData).forEach(key => {
            const column: TableColumn = {
              title: key,
              value: key,
              lastArrayItem: true,
              type: 'text',
              width: '20%'
            }
            columns.push(column)
          })
          this.$set(this.table, 'columns', columns)

          const rows: TableRow[] = []
          status.forEach((step, i) => {
            const row: TableRow = {}
            Object.keys(this.getData).forEach(key => {
              if (key === 'status') {
                row.status = step
              } else {
                row[key] = this.getData[key]
              }
            })
            rows.push(row)
          })
          this.$set(this.table, 'rows', rows)
        }
      } catch (error) {
        console.error('CATCH', this.$options.name, 'prepareData error', error)
      }
    },
  },
})
</script>

<style lang="stylus" scoped>
.rule
  border 1px solid #c1c163
  margin-bottom: 5px;
  padding: 5px;
.rule-item
  //border 1px solid red
  display flex
  justify-content stretch
  align-items baseline
  .field
    margin 0 3px
    outline: darkgray solid 1px;
    height: 30px;
    padding-left: 5px;
    line-height: 30px;
    background-color: white;
.v-btn.supersmall
  padding-top: 4px
  height: 24px
  width: 24px
  right: 5px
</style>
